import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { SelectionArguments } from '../../../shared/models/selection-arguments';
import { Webdoku } from '../../../shared/models/webdoku';
import { RBCheck } from '@ldw/roesberg';
import { SettingsService } from '../../../shared/settings/settings.service';

@Component({
    selector: 'ldw-web-doku-list-item',
    templateUrl: './web-doku-list-item.component.html',
    styleUrls: ['./web-doku-list-item.component.css'],
    standalone: false
})
export class WebDokuListItemComponent {
  private settings = inject(SettingsService);

  @Input() webDoku!: Webdoku;
  @Output() webdokuSelected: EventEmitter<SelectionArguments> = new EventEmitter();

  public hasStatus(): boolean {
    if (RBCheck.isNullOrEmpty(this.webDoku.statusTitle) && RBCheck.isNullOrEmpty(this.webDoku.statusSubTitle)) {
      return false;
    }
    return true;
  }

  public showDescription() {
    if (this.webDoku == undefined || this.settings == undefined) {
      return false;
    }
    return this.settings.settings.documentMode.showWebDokuDescription &&
      this.webDoku.description != undefined && this.webDoku.description != '';
  }

  public getBorderStyle(): string {
    if (this.webDoku == undefined) {
      return '';
    }
    let css = '';
    let hasValue = false;
    if ((this.webDoku.statusBackground ?? '') != '') {
      css = 'background-color: #' + this.webDoku.statusBackground + ';';
    }
    if ((this.webDoku.statusForeground ?? '') != '') {
      css = css + 'border-color: #' + this.webDoku.statusForeground + ';';
      hasValue = true;
    }
    css = css + 'border: 1px; border-style: solid;';
    return css;
  }

  public getStatusStyle(): string {
    if (this.webDoku == undefined) {
      return '';
    }
    let css = '';
    if ((this.webDoku.statusBackground ?? '') != '') {
      css = 'background-color: #' + this.webDoku.statusBackground + ';';
    }
    if ((this.webDoku.statusForeground ?? '') != '') {
      css = css + 'color: #' + this.webDoku.statusForeground + ';';
    }
    return css;
  }
}
